import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { RoleDTO } from 'src/app/models/RoleDTO.model';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { UserManagementDTO } from 'src/app/models/UserManagementDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { RoleService } from 'src/app/services/role.service';
import { Alert } from 'src/app/shared/models/Alert';
import { UserRequestDTO } from 'src/app/shared/models/UserRequestDto';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { emailValidator } from 'src/app/validators/email.validator';

import { CommonModule } from '@angular/common';
import { FormatPhoneUsDirective } from '../../../directives/format-phone-us.directive';
@Component({
    selector: 'app-view-users',
    templateUrl: './view-users.component.html',
    styleUrl: './view-users.component.css',
    imports: [CommonModule, FormsModule, FormatPhoneUsDirective]
})
export class ViewUsersComponent {
  title: string = 'Summary User';
  fieldsCompleted: boolean = false;

  form = new FormGroup({
    email: new FormControl('', [Validators.required, emailValidator()]), 
  });

  get emailModel() {
    return this.form.get('email');
  }

  idUser: number = 0;
  information: string = 'Information';
  userName: string = '';
  address: string = '';
  city: string = '';
  zipCode?: number = undefined;
  stateSelected: string = '';
  roleSelected: number = 0;
  states: MasterDataDTO[] = [];
  roles: RoleDTO[] = [];
  contactNumber?: string = undefined;
  email: string = '';
  masterdataRequestDTO: MasterdataRequestDTO = {
    idMaster: 1,
  };
  validMail: boolean = false;

  alert: Alert = {} as Alert;
  user: UserManagementDTO = {} as UserManagementDTO;
  isActive: boolean = false;
  UserRequestDTO: UserRequestDTO = {
    userId: undefined,
  };

  constructor(
    private customerService: CustomerService,
    private roleService: RoleService,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {

    this.route.params.subscribe((params) => {
      //console.log(params['id']);
      this.information = 'Plan ID ' + params['id'];
      this.UserRequestDTO.userId = params['id'];
      this.customerService.getCustomerById(this.UserRequestDTO).subscribe(
        ({ StatusCode, Message, Data }) =>
          Data != null
            ? this.handleGetUserByIdSuccess(Data)
            : this.handleSaveError(StatusCode),
        (error) => {
          this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000
          };
          this.alertService.updateAlertState(
            this.alert
          );
          this.clearFields();
          this.clearFields();
        }
      );
    });

    this.permissionsService.validateAccessLevels(MODULE_ID.UserManagement);

    this.customerService.getMastersById(this.masterdataRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetAllStatesSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
      }
    );

    this.roleService.getRoles().subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.HandleGetRoles(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
      }
    );
  }

  handleGetUserByIdSuccess(user: UserDTO) {
    this.user.userId = this.idUser ?? 0;
    this.user.userId = user.userId ?? 0;
    this.user.userNames = user.userNames;
    this.user.userAddress = user.userAddressLine1;
    this.user.userCity = user.userCity;
    this.user.userState = user.userState;
    this.user.zipCode = user.userPostalCode;
    this.user.userPhone = user.userPhone;
    this.user.userMail = user.userMail;
    this.user.roleId = user.listUserRole.length > 0 ? user.listUserRole[0].aRoleId : 0;
    this.user.userStatus = user.userStatus ?? 0;

    this.userName = this.user.userNames;
    this.address = user.userAddressLine1;
    this.zipCode = user.userPostalCode;
    this.stateSelected = user.userState;
    this.contactNumber = user.userPhone;
    this.email = user.userMail ?? '';
    this.city = user.userCity;
    this.isActive = user.userStatus === 1;
    this.roleSelected = user.listUserRole.length > 0 ? user.listUserRole[0].aRoleId : 0;
    this.checkFields();
  }

  HandleGetRoles(roles: RoleDTO[]) {
    //console.log(roles);
    this.roles = roles;
  }

  handleGetAllStatesSuccess(states: MasterDataDTO[]) {
    this.states = states;
  }

  clearFields() {
    this.userName = '';
    this.address = '';
    this.city = '';
    this.zipCode = undefined;
    this.stateSelected = '';
    this.contactNumber = undefined;
    this.email = '';
    this.roleSelected = 0;
  }

  updateUser() {
    this.user.userId = this.UserRequestDTO.userId ?? 0;
    this.user.userNames = this.userName;
    this.user.userAddress = this.address;
    this.user.userCity = this.city;
    this.user.userState = this.stateSelected;
    this.user.zipCode = this.zipCode;
    this.user.userPhone = this.contactNumber;
    const emailValue = this.form.get('email')?.value ?? '';
    this.user.userMail = emailValue;
    this.user.roleId = this.roleSelected;
    this.user.userStatus = this.isActive ? 1 : 0;

    this.customerService.updateUserManagement(this.user).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleUpdateSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
        this.clearFields();
        this.clearFields();
      }
    );
  }

  checkFields() {
    if (
      this.userName &&
      this.address &&
      this.city &&
      this.stateSelected &&
      this.zipCode &&
      this.contactNumber &&
      this.form.get('email')?.value &&
      this.roleSelected !== 0
    ) {
      this.fieldsCompleted = true;
    } else {
      this.fieldsCompleted = false;
    }
  }

  goBack() {
    window.location.href = '/user-management';
  }

  handleSaveError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
    this.clearFields();
  }

  async handleUpdateSuccess(user: boolean) {
    if (user === false) {
      this.alert = {
        alertMessage: 'Unexpected error. Please try again later.',
        alertType: 'alert alert-danger',
        alertCenter: false,
        alerTitle: '',
        duration: 3000
      };
      this.alertService.updateAlertState(
        this.alert
      );
    } else {
      this.alert = {
        alertMessage: 'User updated successfully',
        alertType: 'alert alert-success',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };
      localStorage.setItem('AlertObject', JSON.stringify(this.alert));
      this.alertService.updateAlertState(this.alert);

      this.clearFields();
      location.reload();
    }
  }

  checkEmailValidity() {
    const isValid = this.emailModel?.valid;
    if (isValid) {
      this.validMail = true;
    } else {
      this.validMail = false;
    }
    //console.log(this.validMail);
  }
}
